import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { isEmpty } from "lodash";

async function create(data) {
  const response = await http.postData("/dnr-consent", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function update(id, data) {
  const response = await http.putData(`/dnr-consent/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function updateInstruksi(id, data) {
  const response = await http.putData(`/dnr-consent/${id}/instruksi`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http.getData(`/register/${register_id}/dnr-consent`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function find(id: number) {
  const response = await http.getData(`/dnr-consent/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signPenyetuju(id: number, data) {
  const response = await http.putData(`/dnr-consent/${id}/sign-penyetuju`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signDpjp(id: number, data) {
  const response = await http.putData(`/dnr-consent/${id}/sign-dpjp`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signSaksiRs(id: number, data) {
  const response = await http.putData(`/dnr-consent/${id}/sign-saksi-rs`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function markSaksiKeluarga(id: number, data) {
  const response = await http.putData(`/dnr-consent/${id}/mark-saksi-keluarga`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signDpjpInstruksi(id: number, data) {
  const response = await http.putData(`/dnr-consent/${id}/sign-dpjp-instruksi`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function markSaksiKeluargaInstruksi(id: number, data) {
  const response = await http.putData(`/dnr-consent/${id}/mark-saksi-keluarga-instruksi`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function addReview(id: number, data) {
  const response = await http.postData(`/dnr-consent/${id}/review`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function destroy(id: number) {
  const response = await http.deleteData(`/dnr-consent/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  const data = isEmpty(response?.data) ? null : response.data;
  return data;
}

function print(id) {
  window.open(`${http.getAPI()}/dnr-consent/${id}/pdf`, "_blank");
}

export default {
  create,
  update,
  updateInstruksi,
  getByRegister,
  find,
  signPenyetuju,
  signDpjp,
  signSaksiRs,
  markSaksiKeluarga,
  signDpjpInstruksi,
  markSaksiKeluargaInstruksi,
  addReview,
  destroy,
  print
};
